import './tooltip-disable-reason.scss';
import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { DisableReasons as DisableReason } from 'src/utils/enums';
import { DisableReasonContent } from './disable-reason-content';
import { TooltipPlacement } from 'antd/es/tooltip';
import { RestorePolicy } from '../../features/restore-policy-modal/restore-policy';

interface TooltipDisableReasonProps {
    overlayClassName?: string
    disableReason?: DisableReason | string;
    missingPermissions?: boolean;
    children: React.ReactNode;
    placement?: TooltipPlacement;
}

export const TooltipDisableReason: React.FC<TooltipDisableReasonProps> = ({ disableReason, missingPermissions, overlayClassName, children, placement }) => {
    const [showRestoreModal, setShowRestoreModal] = useState(false);

    if (!children) return null;
    if(showRestoreModal) return <>
        <RestorePolicy close={() => setShowRestoreModal(false)} open={showRestoreModal} />
        {children}
        </>;

    return (disableReason || missingPermissions) ?
        <Tooltip overlayClassName={`disable-description-tooltip ${overlayClassName ?? ''}`} destroyTooltipOnHide placement={placement ?? 'bottom'}
            title={<DisableReasonContent disableReason={disableReason} missingPermissions={missingPermissions} restore={() => setShowRestoreModal(true)} />}>
            <>{children}</>
        </Tooltip> :
        <>{children}</>;
};
